import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="bg-background-50 rounded-2xl px-6 md:px-10 py-10 md:py-12">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
              {/* Brand */}
              <div className="sm:col-span-2 lg:col-span-1">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500">
                    <i className="ri-file-list-3-line text-background-50 text-lg"></i>
                  </div>
                  <span className="font-heading text-lg font-semibold text-foreground-950 whitespace-nowrap">
                    CSSSpreadsheet
                  </span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  Your trusted resource for CSSBuy spreadsheets, verified QC databases, and curated product finds. Helping smart shoppers discover the best deals since 2024.
                </p>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Visit kaspreadsheet.com
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </a>
              </div>

              {/* Categories */}
              <div>
                <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4 whitespace-nowrap">
                  Categories
                </h4>
                <ul className="space-y-2">
                  {categories.map((cat) => (
                    <li key={cat.name}>
                      <a
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {cat.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Guides */}
              <div>
                <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4 whitespace-nowrap">
                  Guides
                </h4>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="/cssbuy-spreadsheet-guide"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/cssbuy-spreadsheet-guide');
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }}
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      CSSBuy Spreadsheet Guide
                    </a>
                  </li>
                  <li>
                    <a
                      href="/"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/');
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }}
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Home
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      kaspreadsheet.com
                    </a>
                  </li>
                </ul>
              </div>

              {/* Legal */}
              <div>
                <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4 whitespace-nowrap">
                  Legal
                </h4>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Terms of Service
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Bottom bar */}
            <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-400 whitespace-nowrap">
                &copy; 2026 CSSSpreadsheet. All rights reserved. Not affiliated with CSSBuy.
              </p>
              <div className="flex items-center gap-4">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer"
                >
                  <i className="ri-global-line text-sm"></i>
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer"
                >
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}